import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AdminFormPage } from "@components/CatalogIndex";
import { ContactForm } from "../ContactForm/ContactForm";
import { useContactMutations } from "../api";
import { emptyContactForm } from "../types";
import type { ContactFormValues } from "../types";

const FORM_ID = "contact-form";

export const ContactNew = (): JSX.Element => {
  const navigate = useNavigate();
  const { id = "" } = useParams();
  const { create } = useContactMutations(id);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values: ContactFormValues) => {
    setSubmitting(true);
    try {
      const result: any = await create(values);
      const newId = result?.data?.id;
      navigate(newId ? `../${newId}/edit` : "..", {
        relative: "path",
        state: {
          toast: { variant: "success", text: `'${values.name}' saved` },
        },
      });
    } catch (err) {
      console.error("Failed to create contact", err);
      setSubmitting(false);
    }
  };

  return (
    <AdminFormPage
      title="Add a Contact"
      formId={FORM_ID}
      onCancel={() => navigate("..", { relative: "path" })}
      isSubmitting={submitting}
    >
      <ContactForm
        id={FORM_ID}
        initialValues={emptyContactForm}
        isSubmitting={submitting}
        onSubmit={handleSubmit}
      />
    </AdminFormPage>
  );
};

export default ContactNew;
